import { render, staticRenderFns } from "./salmonthcountimp.vue?vue&type=template&id=1594d0a7&scoped=true&"
import script from "./salmonthcountimp.vue?vue&type=script&lang=js&"
export * from "./salmonthcountimp.vue?vue&type=script&lang=js&"
import style0 from "./salmonthcountimp.vue?vue&type=style&index=0&id=1594d0a7&lang=scss&scoped=true&"
import style1 from "./salmonthcountimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1594d0a7",
  null
  
)

export default component.exports